
import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { DynamicLayout } from '../../formbuilder';

const results = {
  next: {
    next: newStepValue,
    description: 'Next',
  },
  error: {
    next: newStepValue,
    description: 'Error',
  },
};

export const chatdesk: DynamicLayout = {
  json: {
    menu: {
      name: '',
      menuType: 'chatdesk',
      chatdesk: {
        provider: 'Touch',
        sandboxIntegration: '',
        productionIntegration: '',
        department: '',
      },
      results: results
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.name',
    'menu.chatdesk.sandboxIntegration',
    'menu.chatdesk.productionIntegration',
    'menu.chatdesk.department',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.name',
        'menu.chatdesk.sandboxIntegration',
        'menu.chatdesk.productionIntegration',
        'menu.chatdesk.department',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      placeholder: 'Name the node ',
      validators: {
        required: true,
      },
    },
    sandboxIntegration: {
      type: 'dropdown',
      label: 'Sandbox Integration',
      placeholder: 'Select Sandbox Integration',
      validators: {
        required: true,
      },
      attributes: {
        options: {},
      },
    },
    productionIntegration: {
      type: 'dropdown',
      label: 'Production Integration',
      placeholder: 'Select Production Integration',
      validators: {
        required: true,
      },
      attributes: {
        options: {},
      },
    },
    department: {
      type: 'dropdown',
      label: 'Department',
      placeholder: 'Select Department',
      validators: {
        required: false,
      },
      attributes: {
        options: {},
      },
    },
    results: {
      dataType: 'keyObject',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        description: {
          type: 'text',
          label: 'Description',
          attributes: {
            readonly: true,
          },
        },
        next: {
          type: 'next',
          label: 'Point to',
        },
      },
    },
  },
  data: {
    results: {
      next: newStepValue,
      description: '',
    },
  },
};
